<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <filtros :tipo="'assistencias'" @filtrar="filtrar($event)" @exportar="exportar($event)" :listaStatus="getStatus()"></filtros>
        <div v-if="isLoading">
            <b-loading active></b-loading>
        </div>
        <div v-else>     

            <b-table v-if="lista.length>0" :data="lista"
                    :loading="isLoading"                    
                    striped
                    hoverable                                                            
                    backend-sorting
                    :opened-detailed="detalhesAbertos"
                    :show-detail-icon="true"
                    custom-detail-row
                    detail-transition="fade"
                    detailed
                    detail-key="id"                      
                    sort-icon-size="is-small"
                    >                                       

                    <b-table-column  v-if="false" v-slot="props" field="id" :label="$t('SISTEMA.CODIGO')" >
                        {{ props.row.id }} 
                    </b-table-column>                     
                    <b-table-column v-slot="props" field="clienteCodigoExterno" :label="$t('SISTEMA.CLIENTE')" >
                        {{ props.row.clienteCodigoExterno }} - {{ props.row.clienteNome }}
                    </b-table-column> 
                    
                    <b-table-column v-slot="props" field="Unidade" :label="$t('SISTEMA.UNIDADE')" >
                        {{ props.row.unidadeNome }}
                    </b-table-column>                       

                    <b-table-column v-slot="props" field="Custo" :label="$t('MODALCADASTROOCORRENCIAS.CUSTO')" >
                        {{ props.row.custoNome }}
                    </b-table-column> 


                    
                    <b-table-column v-slot="props" field="Agendamento" :label="$t('MODALCADASTROOCORRENCIAS.AGENDAMENTO')" >                        
                        {{ (props.row.dataHoraAgendamento) ? $moment(props.row.dataHoraAgendamento).format('DD/MM/YYYY') : "a definir " }}
                    </b-table-column> 
                    
                    <b-table-column v-slot="props" field="Elist" :label="$t('MODALCADASTROOCORRENCIAS.ELIST')" >
                        {{ props.row.eList }}
                    </b-table-column>                

                    <b-table-column v-slot="props" field="Valor" :label="$t('Valor')" >
                        <div v-for="(v, index) in props.row.valor?.split(',')" :key="index">
                            {{ retornarValorFormatado(v) }}
                        </div>
                    </b-table-column>
                    
                    <b-table-column v-slot="props" field="Acao" :label="''" >


                        <div style="display: flex;">

                            <span v-if="props.row.dataHoraCancelado !=null">
                                <b-icon icon="close-circle"
                                                size="is-small"                                    
                                                :title="$t('GUIAATENDIMENTO.ASSISTENCIAEXCLUIDA')"
                                                type="is-danger"></b-icon> 
                            </span>                                                        
                            <span v-else-if="props.row.dataHoraConcluido !=null">
                                <b-icon icon="check"
                                                size="is-small"                                    
                                                :title="$t('GUIAATENDIMENTO.ASSISTENCIACONCLUIDA')"
                                                type="is-success"></b-icon> 
                            </span>
                            <span v-else>
                                <b-icon icon="information"
                                                size="is-small"                                    
                                                :title="$t('GUIAATENDIMENTO.ASSISTENCIANAOCONCLUIDA')"
                                                type="is-warning"></b-icon>                                                             
                            </span>                                                                                                                          
                            <b-button :title="$t('SISTEMA.EDITAR')" class="ml-1  is-small is-primary" @click="abrirGuia(props.row.guiaId,props.row.unidadeId)"  icon-left="pencil"></b-button>   
                            
                        </div>                          


                    </b-table-column>    
                    

                    <template slot="detail" slot-scope="props">
                            <tr >                                        
                                <td colspan="2" >
                                    <span>                                                
                                        <b>CADASTRO: </b> {{$moment(props.row.dataHoraCadastro).format('DD/MM/YYYY HH:mm') }}                                                          
                                    </span> 
                                    <br>                                                                                                                                                                               
                                    <span>
                                        <b>PEÇA(s): </b>{{props.row.titulo}}                                     
                                    </span>
                                </td>
                                <td colspan="4" >   
                                    
                                    <span>                                                
                                        <b>CONFERENTE: </b> {{props.row.funcionarioConferenteNome}}                                                             
                                    </span> 
                                    <br>                                                                                                                                                                               
                                    <span>
                                        <b>OBSERVAÇÃO: </b><span v-html="tratamentoQuebraLinha(props.row.observacao)"></span>                                   
                                    </span>                                    
                                    
                                </td>
                                <td></td>
                                <td></td>

                            </tr>
                    </template>  
                             
                    
                    

            </b-table>              
          
        </div>
    </section>
</template>

<script>
    import { mapGetters,mapState } from 'vuex'
    import titlebar from '@/components/titlebar.vue'
    import filtros from '@/components/filtrosRelatorio.vue';

    export default {
        data() {
            return {
                isLoading: false ,
                lista:[]
            }
        },
        components: {
            titlebar,
            filtros
        },
        computed: {
            titleStack() {
                return [
                    'Relatório',                                        
                    'Pós-Venda',
                    'Assistências'
                ]
            },
            ...mapGetters([
                'isInRole'
            ]),
            ...mapState([
                'unidadeId',
                'config',                                             
                'usuario', 
            ]),  
          
            detalhesAbertos() {
                return this.lista.map(item => item.id);
            }                      
        },        
        methods: {
            tratamentoQuebraLinha(texto){                
                return (texto) ? texto.replaceAll('\\n', '<br/>') : '';
            },              
            isMensagem(item){

                return item.tipo == 2 ? ' mensagem-color ' : null;

            },               
            abrirGuia(guiaId,unidadeId){

                this.$router.push({ name: 'guia', params: { id: guiaId, atualizarUnidadeId:unidadeId,fluxoVenda:true }})                                
                this.$parent.close();

            },                
            getStatus(){

                 const listaStatus = [
                                    {id:"todos", descricao:"Todos"},
                                    {id:"cancelados", descricao:"Cancelados"},
                                    {id:"pendentes", descricao:"Pendentes"},
                                    {id:"finalizados", descricao:"Finalizados"},
                                ];


                return listaStatus;

            },
            filtrar(filtros){

                    const params = {     
                        nome: (filtros.nome !=null) ? filtros.nome : null,                       
                        dataFiltro: (filtros.dataFiltro !=null) ? filtros.dataFiltro : null,
                        status: (filtros.status !=null) ? filtros.status : null,
                        custoId: (filtros.custoId !=null) ? filtros.custoId : null,
                        dataInicial: (filtros.datas[0] !=null)  ? this.$moment(filtros.datas[0]).format('YYYY-MM-DDTHH:mm:ss') : null,
                        dataFinal:  (filtros.datas[1] !=null) ?  this.$moment(filtros.datas[1]).format('YYYY-MM-DDTHH:mm:ss') : null,                                                          
                        funcionarioLogadoId: this.usuario.funcionarioId,                        
                    }


                    if (filtros.unidade?.id != null){                         
                        params.unidadeId = filtros.unidade?.id;
                    }else if (filtros.unidade?.id == null && !this.usuario.administrador){ 
                        params.unidadeId = this.unidadeId;
                    }                    

                this.carregarLista(params);  

            },

            exportar(filtros){

                    const params = [];

                    if (filtros.dataFiltro != null) params.push(`dataFiltro=${filtros.dataFiltro}`);
                    if (filtros.status != null) params.push(`status=${filtros.status}`);
                    if (filtros.datas[0] != null) params.push(`dataInicial=${this.$moment(filtros.datas[0]).format('YYYY-MM-DDTHH:mm:ss')}`);
                    if (filtros.datas[1] != null) params.push(`dataFinal=${this.$moment(filtros.datas[1]).format('YYYY-MM-DDTHH:mm:ss')}`);
                    if (filtros.funcionario?.id!= null) params.push(`funcionarioId=${filtros.funcionario?.id}`);
                    
                    
                    if (filtros.unidade?.id != null){ 
                        params.push(`unidadeId=${filtros.unidade?.id}`);   
                    }else if (filtros.unidade?.id == null && !this.usuario.administrador){ 
                        params.push(`unidadeId=${this.unidadeId}`);   
                    }
                    
                    params.push(`funcionarioLogadoId=${this.usuario.funcionarioId}`);                     
                                                                                                                                                                                                                                                            
                    window.open(`/api/relatorio/AssistenciasXLS?${params.join('&')}`,'_blank');
                
            },                              
            carregarLista(params){   
                
                    this.isLoading = true;
                    this.$http.post('/api/relatorio/Assistencias', params)
                    .then(res => res.data)
                    .then(data => {                         
                            this.lista = data;                           
                    }).finally(() => {
                        this.isLoading = false;
                    })
                    
            },
            retornarValorFormatado(valor){
                const valorParse = parseFloat(valor);
                return valorParse.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                });
            },
 
            
        }
    }
</script>